import { AnimatePresence, motion } from "framer-motion"
import { useLocation } from "react-router-dom"

import { MOTION } from "@supabank/ui/motion"

export function PageTransitionLayer() {
  const location = useLocation()

  return (
    <AnimatePresence mode="wait">
      <motion.div
        key={location.key}
        aria-hidden
        className="pointer-events-none fixed inset-0 z-[45] bg-background"
        initial={{ opacity: 0.18 }}
        animate={{ opacity: 0 }}
        exit={{ opacity: 0 }}
        transition={{ duration: MOTION.dur.sm, ease: MOTION.ease.standard }}
      />
    </AnimatePresence>
  )
}
